import React, {Component} from 'react'
import './expand-collapse-panel.css'

class ExpandCollapsePanel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isExpanded: false,
    }
  }

  getClassNames = () => {
    let classes = ['expand-collapse-ctr']
    if (this.state.isExpanded) {
      classes.push('expanded')
    } else {
      classes.push('collapsed')
    }
    return classes.join(' ')
  }

  handleClick = () => {
    this.setState({
      isExpanded: !this.state.isExpanded,
    })
  }

  render () {
    const {l, heading, count, headingClassName} = this.props
    return (
      <div className={this.getClassNames()}>
        <div>
          <h4 ref={this.props.setTriggerRef ? this.props.setTriggerRef : () => {}}
            title={this.state.isExpanded ? l('Collapse') : l('Expand')}
            className={`expand-collapse-trigger ${headingClassName}`}
            onClick={this.handleClick}>
            <span>{l(heading)}</span>
            {count ? <span className='right-positioned-header'>{count}</span> : null}
          </h4>
          <div className='expandable-content'>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default ExpandCollapsePanel



// WEBPACK FOOTER //
// ./src/elements/expand-collapse-panel.js